/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateSalesOrderPaymentDto = {
  /**
   * ID of the sales order
   */
  salesOrderId: number;
  /**
   * Payment amount
   */
  paymentAmount: number;
  /**
   * Payment method code (e.g., CASH, CARD, QR, or any custom payment method code)
   */
  paymentMethod: string;
  /**
   * Payment type
   */
  paymentType: CreateSalesOrderPaymentDto.paymentType;
  /**
   * Reference for the specific item (if applicable)
   */
  itemReference?: string;
  /**
   * Bank reference number (for bank transfers)
   */
  bankReference?: string;
  /**
   * QR transaction ID (for QR payments)
   */
  qrTransactionId?: string;
  /**
   * Change given to customer
   */
  changeGiven?: number;
  /**
   * Payment notes
   */
  paymentNotes?: string;
  /**
   * Installment number (for installment payments)
   */
  installmentNumber?: number;
  /**
   * Due date for installment payments
   */
  dueDate?: string;
  /**
   * Commercial payment date/time (ISO 8601). Requires modify_sale_date permission; ignored otherwise.
   */
  paymentDate?: string;
};
export namespace CreateSalesOrderPaymentDto {
  /**
   * Payment type
   */
  export enum paymentType {
    ITEM = 'ITEM',
    ORDER = 'ORDER',
  }
}
